import React from "react";
import { useTranslation } from "react-i18next";
import "./EstimatorBenefits.css";
import sectionImage from "../../../../assets/images/estimator/esti.png";

const POINT_KEYS = ["p1", "p2", "p3", "p4", "p5"];

const EstimatorBenefits = ({ onCalculateNow }) => {
  const { t } = useTranslation();

  return (
    <section className="estimator-benefits">
      <div className="estimator-benefits__container">
        <div className="estimator-benefits__media">
          <img src={sectionImage} alt={t("sections.estimator.benefits.imageAlt")} />
        </div>

        <div className="estimator-benefits__content">
          <h2>
            {t("sections.estimator.benefits.title")}{" "}
            <span>{t("sections.estimator.benefits.titleAccent")}</span>
          </h2>

          <p className="estimator-benefits__subtitle">
            {t("sections.estimator.benefits.subtitle")}
          </p>

          <ul>
            {POINT_KEYS.map((key) => (
              <li key={key}>{t(`sections.estimator.benefits.points.${key}`)}</li>
            ))}
          </ul>

          <button className="buttongyp estimator-benefits__btn" type="button" onClick={onCalculateNow}>
            {t("sections.estimator.benefits.cta")}
          </button>
        </div>
      </div>
    </section>
  );
};

export default EstimatorBenefits;
